import { Box } from '@material-ui/core';

import { SButton, SInput, SText } from '@setvi/shared/components';

import { useStyles } from './styles';

interface LocationInputProps {
  value: string;
  disabled: boolean;
  generating: boolean;
  canGenerate: boolean;
  onChange: (value: string) => void;
  onGenerate: () => void;
}

export const LocationInput = ({
  value,
  disabled,
  generating,
  canGenerate,
  onChange,
  onGenerate
}: LocationInputProps) => {
  const classes = useStyles();

  return (
    <Box>
      <SText title="Enter your store's Location ID and click Generate." />
      <SText title="Review the preview, then click Add to Cart." />
      <Box mt={2} className={classes.row}>
        <Box flex={1}>
          <SInput
            newDesign
            value={value}
            placeholder="Enter location"
            disabled={disabled}
            onChange={e => onChange(e.target.value)}
          />
        </Box>
        <SButton
          variant="outlined"
          color="primary"
          loading={generating}
          disabled={!canGenerate}
          onClick={onGenerate}>
          Generate
        </SButton>
      </Box>
    </Box>
  );
};
